import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-176977b4")

_pushScopeId("data-v-176977b4")
const _hoisted_1 = { class: "r-grid container" }
const _hoisted_2 = { class: "accordion-title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, "New Request", -1)
const _hoisted_4 = { class: "button-toggle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_plusSVG = _resolveComponent("plusSVG")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: _ctx.link }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_plusSVG)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
})